const capitalize = {
  filters: {
    capitalize: function (value) {
      if (!value) return "";

      value = value.toLowerCase();

      let splitChar = [" ", "-"];
      splitChar.forEach((char) => {
        var splitStr = value.split(char);
        for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        value = splitStr.join(char);
      });

      return value;
    },
  }
}

export default capitalize;


// WEBPACK FOOTER //
// ./src/mixins/capitalize.js